(() => {
  document.querySelectorAll('[data-journal-selection]').forEach((form) => {
    if (form.dataset.initialized) return;
    form.dataset.initialized = 'true';

    const button = form.querySelector('[data-selection-submit]');
    const consent = form.querySelector('[data-selection-consent]');
    const status = form.querySelector('[data-selection-status]');
    const review = form.querySelector('[data-selection-review]');
    const items = [...form.querySelectorAll('[data-selection-variant]')].map((input) => ({
      id: input.value,
      quantity: 1,
    }));
    let submitted = false;

    const updateButton = () => {
      button.disabled = submitted || items.length === 0 || Boolean(consent && !consent.checked);
    };
    consent?.addEventListener('change', updateButton);
    updateButton();

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (button.disabled || submitted) return;
      submitted = true;
      updateButton();
      if (consent) consent.disabled = true;
      form.setAttribute('aria-busy', 'true');
      status.textContent = 'Adding your selection…';

      try {
        // The Liquid route retains the storefront locale. Add, never replace, the existing cart.
        const response = await fetch(`${form.action}.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
          signal: AbortSignal.timeout(20000),
        });
        const result = await response.json();
        if (!response.ok || !Array.isArray(result.items) || result.items.length !== items.length ||
          !items.every((item) => result.items.some((added) => String(added.id) === item.id))) {
          throw new Error('Incomplete cart response');
        }
        status.textContent = 'Selection added. Opening your cart…';
        window.location.assign(form.dataset.cartUrl);
      } catch {
        // A failed/unknown response can follow a partial write. Never retry automatically.
        status.textContent = 'We couldn’t confirm the full selection. Some bottles may have been added, or availability may have changed. Review your cart before adding anything else.';
        review.hidden = false;
        review.focus();
      } finally {
        form.removeAttribute('aria-busy');
      }
    });
  });
})();
